import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environment/environment';
import {
  Facility,
  CreateFacilityDto,
  UpdateFacilityDto,
} from '../models/facility.model';

@Injectable({
  providedIn: 'root',
})
export class FacilityService {
  private readonly apiUrl = `${environment.apiUrl}/facilities`;

  constructor(private http: HttpClient) {}

  getFacilities(): Observable<Facility[]> {
    return this.http.get<Facility[]>(this.apiUrl);
  }

  getFacilityById(id: string): Observable<Facility> {
    return this.http.get<Facility>(`${this.apiUrl}/${id}`);
  }

  getChildren(parentId: string): Observable<Facility[]> {
    return this.http.get<Facility[]>(`${this.apiUrl}/${parentId}/children`);
  }

  createFacility(dto: CreateFacilityDto): Observable<Facility> {
    return this.http.post<Facility>(this.apiUrl, dto);
  }

  updateFacility(id: string, dto: UpdateFacilityDto): Observable<Facility> {
    return this.http.put<Facility>(`${this.apiUrl}/${id}`, dto);
  }

  deleteFacility(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
